export default __webpack_public_path__ + "static/media/debian.f106a36d.svg";